import { Injectable } from '@angular/core';
import { SalesforceEntityMetadataService } from 'entity-metadata-service-lib';
import { IEntityTypeOption } from 'interfaces-lib';
import { map, Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class SalesforceEntityTypeMappingsService {
  constructor(private entityMetadataService: SalesforceEntityMetadataService) {}

  getEntityTypeOptions(parentEntityType: string): Observable<IEntityTypeOption[]> {
    return this.entityMetadataService.getEntitiesMetadata().pipe(
      map((metadata) =>
        metadata.map((meta) => ({
          value: meta.name,
          label: meta.label,
          isDefault: meta.name === parentEntityType,
        }))
      )
    );
  }
}
